/**
 * Created by intellicar-rinas on 22/9/17.
 */
import historyReport from './reports/historyReport/historyReport';
import gpsReport from './reports/gpsReport';
import alarmReport from './reports/alarmReport';
import tripReport from './reports/tripReport';
import tvsSwiggyReport from './reports/tvsSwiggyReport';
import dailyReport from './reports/dailyReport';
import canDailyReport from './reports/canDailyReport';
import dailyReportMinimal from './reports/dailyReportMinimal';
import summaryReport from './reports/summaryReport';
import refuelReport from './reports/refuelReport';
import overspeedingReport from './reports/overspeedingReport';
import compactorReport from './reports/compactorReport';
import paverReport from './reports/paverReport';
import clutchReport from './reports/clutchReport';
// import mobiliReport from './reports/mobiliReport';
import pilferageReport from './reports/pilferageReport';
import geofenceReport from './reports/geofenceReport';
import advancedFuelReport from './reports/advancedFuelReport/advancedFuelReport';
import greySpotReport from './reports/greySpotReport/greySpotReport';
import aggregatedReport from './reports/aggregatedReport';
import tvsReport from './reports/tvsReport2';
import railwaysReport from './reports/railwaysReport/railwaysReport';
// import tripDetailsReport from './reports/tripDetailsReport';
import panicAlertReport from './reports/panicAlertReport';
import  bmsReport from './reports/bmsReport'
import evReport from './reports/evReport';
import downloadReport from './reports/downloadReport';
import monthlyReport from './reports/monthlyReport';
import canDataReport from './reports/canDataReport';
import canDataDumpReport from './reports/canDataDumpReport';
import chargeReport from './reports/chargeReport';
import peakReport from './reports/peakReport'
import hourlyReport from './reports/hourlyReport';
import rangeReport from './reports/rangeReport';
import groupReport from './reports/groupReport';
import tripReport2 from './reports/tripReport2';
import immobReport from './reports/immobReport';
import cmdStatusReport from './reports/cmdStatusReport';
import tripwiseReport from './reports/tripwiseReport'
import chargeHistoryReport from './reports/chargingHistoryReport'
import mileageReport from './reports/mileageReport'
import jemCanDataSnapshot from './reports/jemCanDataReport'
import jemCanDataDumpReport from './reports/jemCanDataDumpReport'
import bgCanDataSnapshot from './reports/bgCanDataReport'
import bgCanDataDumpReport from './reports/bgCanDataDumpReport'
import clnBatteryReport from './reports/clnBatteryReport'
import clnSubscriptionReport from './reports/clnSubscriptionReport'
import ebikeReport from './reports/ebikeReport'

export default [
    historyReport,
    // mobiliReport,
    gpsReport,
    overspeedingReport,
    alarmReport,
    tripReport,
    tripReport2,
    dailyReport,
    dailyReportMinimal,
    summaryReport,
    canDailyReport,
    rangeReport,
    clutchReport,
    compactorReport,
    paverReport,
    refuelReport,
    pilferageReport,
    geofenceReport,
    //greySpotReport,
    advancedFuelReport,
    tvsReport,
    railwaysReport,
    // tripDetailsReport,
    panicAlertReport,
    bmsReport,
    aggregatedReport,
    evReport,
    tvsSwiggyReport,
    downloadReport,
    monthlyReport,
    canDataReport,
    canDataDumpReport,
    chargeReport,
    peakReport,
    hourlyReport,
    // canDailyReport,
    // rangeReport,
    groupReport,
    immobReport,
    cmdStatusReport,
    tripwiseReport,
    chargeHistoryReport,
    mileageReport,
    jemCanDataSnapshot,
    jemCanDataDumpReport,
    bgCanDataSnapshot,
    bgCanDataDumpReport,
    clnBatteryReport,
    clnSubscriptionReport,
    ebikeReport
]